import { useEffect, useRef, useState } from 'react';
import { useTranslate } from 'ra-core';
import { Asset, SecurityInventoryCategory } from '@x-guard/xgac-types/xgac';
import { useOutsideAlerter } from '../../../../../utils/useOutsideAlerter';
import { FilterRow } from '../../../components/deviceFilters';
import { InventoryItemFilter } from '../util';

export const InventoryItemFilters = (props: {
  filters: InventoryItemFilter;
  onChange: (filters: InventoryItemFilter) => void;
  open: boolean;
  setOpen: (open: boolean) => void;
  categories: SecurityInventoryCategory[];
  users: Asset[];
}) => {

  const translate = useTranslate();
  const filterRef = useRef(null);
  const [openFilter, setOpenFilter] = useState<null | 'categories' | 'users'>(null);
  const [innerFilters, setInnerFilters] = useState(props.filters);

  useOutsideAlerter(filterRef, () => props.setOpen(false));

  useEffect(() => {

    if (props.open) {

      setInnerFilters(props.filters);

    }

  }, [props.open, props.filters]);

  if (!props.open) {

    return null;

  }
  return (
    <div className="device-filter-div" ref={filterRef}>
      <div className="device-filter-div-inner">
        <ul onClick={() => {

          setOpenFilter(null);

        }}>
          <FilterRow
            label={'resources.security-inventory-items.text.filter_category'}
            buttonLabelAll={'resources.security-inventory-items.text.all_categories'}
            buttonLabelSome={'resources.security-inventory-items.text.categories_chosen'}
            open={openFilter === 'categories'}
            setOpenFilter={() => {

              if (openFilter === 'categories') {

                setOpenFilter(null);
                return;

              }
              setOpenFilter('categories');

            }}
            onChange={(selectedOptions: string[] | number[]) => setInnerFilters(
              { ...innerFilters, categories: selectedOptions as string[] },
            )}
            options={props.categories.map((category) => ({ label: category.name, value: category._id }))}
            selected={innerFilters.categories}
          />
          <FilterRow
            label={'resources.security-inventory-items.text.filter_user'}
            buttonLabelAll={'resources.security-inventory-items.text.all_users'}
            buttonLabelSome={'resources.security-inventory-items.text.users_chosen'}
            open={openFilter === 'users'}
            setOpenFilter={() => {

              if (openFilter === 'users') {

                setOpenFilter(null);
                return;

              }
              setOpenFilter('users');

            }}
            onChange={(selectedOptions: string[] | number[]) => setInnerFilters(
              { ...innerFilters, users: selectedOptions as string[] },
            )}
            options={props.users.map((user) => ({ label: user.name, value: user._id }))}
            selected={innerFilters.users}
          />
        </ul>
        <div className="device-filter-buttons">
          <button onClick={() => {

            props.onChange({
              categories: [],
              users: [],
            });
            props.setOpen(false);

          }}>{translate('resources.buttons.text.remove_filters')}</button>
          <button onClick={() => {

            props.onChange(innerFilters);
            props.setOpen(false);

          }}>{translate('resources.buttons.text.save_filters')}</button>
        </div>
      </div>
    </div>
  );

};
